import { put, call, select, putResolve } from 'redux-saga/effects'

// @ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { translateLKMessage } from '../translate'
import { getSelects } from '../selectors'
import { CLIENT_VALIDATION_RESULTS_MODAL } from '../constants'
import { addToWatchlist, submitAddClientFormData } from 'src/store/client'
import { beforeClientAddEdit } from 'src/store/event'
import { view as eventsView } from 'src/store/event'

function getMatrixParams(addClientData, selects) {
  const {
    action,
    ID,
    hash,
    IND_Name,
    IND_Surname,
    IND_Name_ALT,
    IND_Surname_ALT,
    IND_DOB,
    CardNumber,
    OtherIDNumber,
    CitizenshipID,
    CellPhone,
    FullName,
    ClientType,
  } = addClientData

  const country = selects.Country.find((c) => c.ID === CitizenshipID)

  return {
    SP_ACT: action === 'add' ? 0 : 1,
    AMLOperTypeID: 10,
    Name: IND_Name,
    Surname: IND_Surname,
    Name_ALT: IND_Name_ALT,
    Surname_ALT: IND_Surname_ALT,
    PersonalNo: CardNumber,
    DateOfBirth: IND_DOB,
    DocNo: OtherIDNumber,
    CTCode: country && country.CTCode,
    CitizenshipID,
    ClientType,
    CellPhone,
    ClientID: ID,
    HashSum_ClientID_: hash,
    FullName,
  }
}

export default function* submitClientData({ payload, meta: { resolve, reject } }) {
  try {
    // here was whitelist validation RIP

    // checking client validation matrix
    let session

    if (!payload.isResubmit) {
      const selects = yield select(getSelects)
      // const {
      //   Data: eventData,
      //   Data: { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ },
      // } = yield call(Event.beforeClientAddEdit, getMatrixParams(payload.params, selects))

      //UPDATED API REQUEST events_api action: before_client_add_edit
      const response = yield putResolve<any>(beforeClientAddEdit(getMatrixParams(payload.params, selects)))

      const {
        payload: eventData,
        payload: { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_, message },
      } = response

      if (message) {
        throw { Error: { Message: message } }
      }

      if (ErrorLevel === 150 || ErrorLevel === 200) {
        // const { Data } = yield call(Event.view, { WHLSessionID, HashSum_WHLSessionID_ })
        //UPDATED API REQUEST events_view_api
        const result = yield putResolve<any>(
          eventsView({
            WHLSessionID,
            HashSum_WHLSessionID_,
          }),
        )

        if (!eventsView.fulfilled.match(result)) {
          throw { Error: { Message: result.payload } }
        }

        const { payload: Data } = result

        yield put(
          LKModalActions.open({
            name: CLIENT_VALIDATION_RESULTS_MODAL,
            Data,
            ErrorLevel,
            sessionId: WHLSessionID,
            sessionHash: HashSum_WHLSessionID_,
            askForConfirm: ErrorLevel === 150,
          }),
        )

        return reject(eventData)
      }

      session = { WHLSessionID, HashSum_WHLSessionID_ }
    } else {
      session = { WHLSessionID: payload.sessionId, HashSum_WHLSessionID_: payload.sessionHash }
    }

    // const res = yield call(Client.submitAddClientFormData, { ...session, ...payload.params })
    // const {
    //   Data,
    //   Data: { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ },
    // } = res

    //UPDATED API REQUEST 'client_add'
    const res = yield putResolve<any>(submitAddClientFormData({ ...session, ...payload.params }))
    if (submitAddClientFormData.fulfilled.match(res)) {
      const {
        payload: Data,
        payload: { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ },
      } = res
      if (WHLSessionID) {
        //@ts-ignore
        // const { Data: viewData } = yield call(Event.view, {
        //   WHLSessionID,
        //   HashSum_WHLSessionID_,
        // })

        //UPDATED API REQUEST events_view_api
        const eventsViewResult = yield putResolve<any>(
          eventsView({
            WHLSessionID,
            HashSum_WHLSessionID_,
          }),
        )

        if (!eventsView.fulfilled.match(eventsViewResult)) {
          throw { Error: { Message: eventsViewResult.payload } }
        }

        const { payload: viewData } = eventsViewResult

        yield put(
          LKModalActions.open({
            name: CLIENT_VALIDATION_RESULTS_MODAL,
            Data: viewData,
            ErrorLevel,
          }),
        )
      }

      if (payload.addClientInWatchList) {
        // yield call(Client.addToWatchlist, Data.ClientID, Data.HashSum_ClientID_) // eslint-disable-line
        //UPDATED API REQUEST client_oper_api page=watchlist
        const watchlistResult = yield putResolve<any>(
          addToWatchlist({
            ClientID: Data.ClientID,
            HashSum_ClientID_: Data.HashSum_ClientID_,
          }),
        )
        if (addToWatchlist.rejected.match(watchlistResult)) {
          yield put(
            //@ts-ignore
            LKModalActions.openError(watchlistResult.payload.message),
          )
        }
      }

      return resolve({
        ...Data,
        ClientType: payload.params.ClientType,
      })
    } else {
      yield put(LKModalActions.openError(translateLKMessage(res.error.message)))
      return reject(res.error)
    }
  } catch (error) {
    if (!error.Error.FailedFields) {
      const errorMessage = error.Error.Message || error.Error.Text
      yield put(LKModalActions.openError(translateLKMessage(errorMessage)))
    } else {
      yield put(LKModalActions.openError(translateLKMessage('ERR_FILL_REQUIRED_FIELDS'), 'ERR_FILL_REQUIRED_FIELDS'))
    }

    return reject(error)
  }
}
